import React, { useEffect } from 'react';
import { LOGOUT_URL } from '../constants';

const Logout = () => {
  const loginReturn = <div>Redirecting to external site...</div>;
  useEffect(() => {
    // Redirect to the external URL
    window.location.href = LOGOUT_URL;
  }, []);
  return loginReturn;
};

export default Logout;